import { newsList } from "@/mocks/news";

export default function NewsSection() {
  const lead = newsList[0];
  const secondary = newsList.slice(1, 5);
  const rest = newsList.slice(5);

  return (
    <section className="bg-background-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
          <div>
            <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              最新影视资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              开播动态、剧集口碑与行业资讯，第一时间掌握影视风向
            </p>
          </div>
          <span className="flex items-center gap-1.5 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-600">
            <i className="ri-flashlight-line"></i>
            每日更新
          </span>
        </div>

        <div className="grid grid-cols-1 gap-5 lg:grid-cols-2">
          <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:-translate-y-1 cursor-pointer">
            <div className="h-52 w-full overflow-hidden bg-background-200 md:h-64">
              <img
                src={lead.cover}
                alt={lead.title}
                title={`${lead.title} 影视资讯`}
                className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-5">
              <div className="flex items-center gap-2 text-xs text-foreground-500">
                <span className="rounded-md bg-accent-100 px-2 py-0.5 font-medium text-accent-900">
                  {lead.category}
                </span>
                <span>{lead.date}</span>
                <span>· {lead.author}</span>
              </div>
              <h3 className="mt-3 font-heading text-lg font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-600 md:text-xl">
                {lead.title}
              </h3>
              <p className="clamp-2 mt-2.5 text-sm leading-relaxed text-foreground-600">
                {lead.summary}
              </p>
            </div>
          </article>

          <div className="flex flex-col gap-3">
            {secondary.map((item) => (
              <article
                key={item.id}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-300 cursor-pointer"
              >
                <div className="h-20 w-28 shrink-0 overflow-hidden rounded-md bg-background-200">
                  <img
                    src={item.cover}
                    alt={item.title}
                    title={`${item.title} 影视资讯`}
                    className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center gap-2 text-xs text-foreground-500">
                    <span className="font-medium text-secondary-700">
                      {item.category}
                    </span>
                    <span>{item.date}</span>
                  </div>
                  <h3 className="clamp-2 mt-1.5 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                    {item.title}
                  </h3>
                </div>
              </article>
            ))}
          </div>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {rest.map((item) => (
            <article
              key={item.id}
              className="group flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-all duration-300 hover:-translate-y-1 hover:border-primary-300 cursor-pointer"
            >
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-secondary-100 text-lg text-secondary-800">
                <i className="ri-newspaper-line"></i>
              </span>
              <div className="min-w-0">
                <h3 className="clamp-2 text-sm font-medium leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                  {item.title}
                </h3>
                <p className="mt-1.5 text-xs text-foreground-500">
                  {item.date} · {item.author}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}